import React, { useState, useEffect } from 'react';
import { Camera, Save, Upload, Mail, Phone, Globe, MapPin, User, Landmark, ShieldCheck, FileCheck2, X } from 'lucide-react';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import '../../../css/custom-scrollbar.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import { Base_Url, userdata, updateprofile, Url_For_View_Document } from '../../../config/config';
import { useNavigate } from 'react-router-dom';

const UserProfileEdit = () => {
    const [hasExistingAccount, setHasExistingAccount] = useState(false);
    const [originalAccountNo, setOriginalAccountNo] = useState('');
    const [hasExistingAccountHolder, setHasExistingAccountHolder] = useState(false);
    const [originalAccountHolder, setOriginalAccountHolder] = useState('');
    const [hasExistingBankName, setHasExistingBankName] = useState(false);
    const [originalBankName, setOriginalBankName] = useState('');
    const [hasExistingIfscCode, setHasExistingIfscCode] = useState(false);
    const [originalIfscCode, setOriginalIfscCode] = useState('');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [cancelCheckFile, setCancelCheckFile] = useState(null);
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const [isLoading, isSetLoading] = useState(false);
    const navigate = useNavigate();

    const [profileImagePreview, setProfileImagePreview] = useState(null);
    const [selectedProfileImage, setSelectedProfileImage] = useState(null);

    const [userData, setUserData] = useState({
        id: cusid,
        company_name: "test",
        name: '',
        bio: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        account_holder: '',
        bank_name: '',
        account_no: '',
        ifsc_code: ''
    });

    const handleCancelCheckUpload = (event) => {
        const file = event.target.files[0];
        setCancelCheckFile(file);
    };

    const handleProfileImage = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setSelectedProfileImage(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleCancelCheckRemove = () => {
        setCancelCheckFile(null);
    };


    const generateInitialsAvatar = (name) => {
        if (!name) return null;
        const initials = name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();
        return (
            <div
                className="rounded-full flex items-center justify-center bg-gradient-to-br from-customPurple to-indigo-600 text-white font-bold w-full h-full text-3xl"
            >
                {initials}
            </div>

        );
    };

    useEffect(() => {
        fetchUserData();
    }, [cusid, token]);

    const fetchUserData = async () => {
        const url = Base_Url + userdata;
        if (cusid) {
            try {
                const response = await fetch(url + "/" + cusid, {
                    method: 'GET',
                    headers: {
                        'token': token,
                        'cus_id': cusid,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();
                if (result.status === "SUCCESS") {
                    const { data } = result;
                    // Check for existing bank details
                    if (data.account_no) {
                        setHasExistingAccount(true);
                        setOriginalAccountNo(data.account_no);
                    }
                    if (data.account_holder_name) {
                        setHasExistingAccountHolder(true);
                        setOriginalAccountHolder(data.account_holder_name);
                    }
                    if (data.bank_name) {
                        setHasExistingBankName(true);
                        setOriginalBankName(data.bank_name);
                    }
                    if (data.ifsc_code) {
                        setHasExistingIfscCode(true);
                        setOriginalIfscCode(data.ifsc_code);
                    }

                    setUserData({
                        id: cusid,
                        name: data.name || '',
                        company_name: data.company_name || '',
                        bio: data.bio,
                        email: data.email || '',
                        phone: data.phone || '',
                        website: data.website || '',
                        address: data.address || '',
                        account_holder: data.account_holder_name,
                        bank_name: data.bank_name,
                        account_no: data.account_no || '',
                        ifsc_code: data.ifsc_code
                    });
                    if (data.profile_image) {
                        const profileWithUrl = Url_For_View_Document + data.profile_image
                        setProfileImagePreview(profileWithUrl);
                    }
                    else {
                        setProfileImagePreview(data.profile_image);
                    }
                } else {
                    toast.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Something went wrong. Please try again.');
            }
        }
    };


    const handleSubmit = async () => {
        const formData = new FormData();
        if (hasExistingAccount) {
            formData.append('account_no', originalAccountNo);
        } else {
            formData.append('account_no', userData.account_no);
        }

        if (hasExistingAccountHolder) {
            formData.append('account_holder', originalAccountHolder);
        } else {
            formData.append('account_holder', userData.account_holder);
        }

        if (hasExistingBankName) {
            formData.append('bank_name', originalBankName);
        } else {
            formData.append('bank_name', userData.bank_name);
        }

        if (hasExistingIfscCode) {
            formData.append('ifsc_code', originalIfscCode);
        } else {
            formData.append('ifsc_code', userData.ifsc_code);
        }

        // Append other fields
        for (const key in userData) {
            if (!['account_no', 'account_holder', 'bank_name', 'ifsc_code'].includes(key)) {
                formData.append(key, userData[key]);
            }
        }

        // Append profile image if selected
        if (selectedProfileImage) {
            formData.append('profile_image', selectedProfileImage);
        }

        if (cancelCheckFile) {
            formData.append('cancel_check', cancelCheckFile);
        }

        try {
            isSetLoading(true);
            const response = await axios.post(`${Base_Url}${updateprofile}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cusid,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                isSetLoading(false);
                setTimeout(() => {
                    navigate("/dashboard");
                }, 1000)
            } else {
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.profile_image);
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.account_no);
                toast.error(response.data.message.address);
                toast.error(response.data.message.website);
                toast.error(response.data.message.cancel_check);
                isSetLoading(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Something went wrong. Please try again.');
            isSetLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === 'phone') {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(value)) {
                return;
            }
        }
        if (
            (id === 'account_no' && hasExistingAccount) ||
            (id === 'account_holder' && hasExistingAccountHolder) ||
            (id === 'bank_name' && hasExistingBankName) ||
            (id === 'ifsc_code' && hasExistingIfscCode)
        ) {
            return;
        }
        setUserData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    // ---- small style helpers (presentation only) ----
    const fieldBase = "w-full px-3 py-2 text-sm rounded-lg border transition-all duration-150 outline-none";
    const fieldActive = "bg-white/70 dark:bg-white/5 border-gray-200 dark:border-gray-700 text-gray-800 dark:text-white focus:border-customPurple focus:ring-2 focus:ring-customPurple/20";
    const fieldLocked = "bg-gray-100/70 dark:bg-gray-800/40 border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed";

    return (
        <div className={`h-screen w-full flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gradient-to-br from-indigo-50 via-white to-purple-50'}`}>
            <div className="z-10 shrink-0">
                <NavBar />
            </div>

            <div className="flex flex-1 min-h-0 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}

                {/* Main panel — fixed to viewport height */}
                <div className="flex-1 min-w-0 min-h-0 bg-gray-200 flex flex-col p-3 md:p-4">
                    <div className="flex-1 min-h-0 flex flex-col bg-white/60 dark:bg-white/5 backdrop-blur-xl rounded-2xl border border-white/60 dark:border-gray-700/60 shadow-xl overflow-hidden">

                        {/* Header — stays fixed at top */}
                        <div className="shrink-0 flex items-center justify-between px-5 py-3 border-b border-gray-200/70 dark:border-gray-700/70 bg-gradient-to-r from-white/40 to-transparent dark:from-white/5">
                            <div className="flex items-center gap-2">
                                <span className="w-1.5 h-6 bg-gradient-to-b from-customPurple to-indigo-500 rounded-full"></span>
                                <div>
                                    <h1 className="text-lg font-bold text-gray-800 dark:text-white leading-none">Edit Profile</h1>
                                    <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-1">Manage your personal, contact & payout details</p>
                                </div>
                            </div>
                            <button
                                className="flex items-center gap-2 bg-gradient-to-r from-customPurple to-indigo-600 hover:opacity-90 text-white px-5 py-2 rounded-xl text-sm font-medium transition-all duration-200 shadow-md hover:shadow-lg"
                                onClick={handleSubmit}
                            >
                                {isLoading ? <Spinner /> : <><Save className="w-4 h-4" /><span>Save Changes</span></>}
                            </button>
                        </div>

                        {/* Body — left column fixed, right column scrolls */}
                        <div className="flex-1 min-h-0 flex flex-col lg:flex-row gap-3 p-4 overflow-hidden">

                            {/* Left: Avatar + Bio — FIXED, no scroll */}
                            <div className="lg:w-72 shrink-0 flex flex-col gap-3">
                                <div className="flex flex-col items-center justify-center gap-3 bg-white/70 dark:bg-white/5 rounded-2xl border border-gray-200/70 dark:border-gray-700/60 p-4">
                                    <div className="relative w-28 h-28 md:w-32 md:h-32">
                                        {profileImagePreview ? (
                                            <img
                                                src={profileImagePreview}
                                                alt="Profile"
                                                className="w-full h-full object-cover border-4 border-white dark:border-gray-700 shadow-lg rounded-full"
                                            />
                                        ) : (
                                            <div className="w-full h-full border-4 border-white dark:border-gray-700 shadow-lg rounded-full overflow-hidden">
                                                {generateInitialsAvatar(userData.name)}
                                            </div>
                                        )}
                                        <button
                                            onClick={() => document.getElementById("profileImageInput").click()}
                                            className="absolute bottom-0 right-0 bg-customPurple hover:bg-purple-700 text-white p-2 rounded-full shadow-md transition-transform duration-200 hover:scale-105"
                                        >
                                            <Camera className="w-4 h-4" />
                                        </button>
                                        <input
                                            type="file"
                                            id="profileImageInput"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            style={{ display: 'none' }}
                                            onChange={handleProfileImage}
                                        />
                                    </div>
                                    <div className="text-center">
                                        <p className="text-sm font-semibold text-gray-800 dark:text-white truncate max-w-[10rem]">{userData.name || 'Your Name'}</p>
                                        <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate max-w-[10rem]">{userData.email || 'your@email.com'}</p>
                                    </div>
                                    <div className="w-full pt-2 border-t border-gray-200/70 dark:border-gray-700/60 flex items-center justify-center gap-1.5 text-[11px] text-green-600 dark:text-green-400">
                                        <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                                        Auto-saved on submit
                                    </div>
                                </div>

                                {/* Bio */}
                                <div className="bg-white/70 dark:bg-white/5 rounded-2xl border border-gray-200/70 dark:border-gray-700/60 p-3 flex flex-col gap-1.5 flex-1 min-h-0">
                                    <label htmlFor="bio" className="text-[11px] font-medium text-gray-500 dark:text-gray-400 flex items-center gap-1">
                                        Biography
                                    </label>
                                    <textarea
                                        id="bio"
                                        placeholder="Tell us about yourself..."
                                        value={userData.bio}
                                        onChange={handleInputChange}
                                        className={`${fieldBase} ${fieldActive} resize-none flex-1`}
                                    ></textarea>
                                </div>
                            </div>

                            {/* Right: field sections — SCROLLS */}
                            <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar pr-1">
                                <div className="flex flex-col gap-3">

                                    {/* Public info */}
                                    <div className="bg-white/70 dark:bg-white/5 rounded-2xl border border-gray-200/70 dark:border-gray-700/60 p-3">
                                        <div className="flex items-center gap-2 mb-2">
                                            <User className="w-3.5 h-3.5 text-customPurple" />
                                            <h2 className="text-xs font-semibold text-gray-700 dark:text-gray-200">Public Information</h2>
                                            <span className="ml-auto px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 text-[10px] rounded-full">Visible to others</span>
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                            <div>
                                                <label htmlFor="name" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">Full Name *</label>
                                                <input
                                                    id="name"
                                                    type="text"
                                                    placeholder="Enter your full name"
                                                    value={userData.name}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive}`}
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor="username" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">Username</label>
                                                <input
                                                    id="username"
                                                    type="text"
                                                    placeholder="Choose a username"
                                                    value={userData.company_name}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive}`}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Private info */}
                                    <div className="bg-white/70 dark:bg-white/5 rounded-2xl border border-gray-200/70 dark:border-gray-700/60 p-3">
                                        <div className="flex items-center gap-2 mb-2">
                                            <ShieldCheck className="w-3.5 h-3.5 text-orange-500" />
                                            <h2 className="text-xs font-semibold text-gray-700 dark:text-gray-200">Private Information</h2>
                                            <span className="ml-auto px-2 py-0.5 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 text-[10px] rounded-full">Personal details</span>
                                        </div>
                                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                                            <div>
                                                <label htmlFor="email" className="flex items-center gap-1 text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    <Mail className="w-3 h-3" /> Email <span className="text-[9px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 rounded">RO</span>
                                                </label>
                                                <input id="email" type="email" disabled value={userData.email} onChange={handleInputChange} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="phone" className="flex items-center gap-1 text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    <Phone className="w-3 h-3" /> Phone <span className="text-[9px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 rounded">RO</span>
                                                </label>
                                                <input id="phone" type="tel" disabled value={userData.phone} onChange={handleInputChange} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="website" className="flex items-center gap-1 text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    <Globe className="w-3 h-3" /> Website
                                                </label>
                                                <input id="website" type="url" placeholder="https://..." value={userData.website} onChange={handleInputChange} className={`${fieldBase} ${fieldActive}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="UserId" className="flex items-center gap-1 text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    User ID <span className="text-[9px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 rounded">SYS</span>
                                                </label>
                                                <input id="UserId" type="text" disabled value={userData.id} onChange={handleInputChange} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div className="col-span-2 lg:col-span-4">
                                                <label htmlFor="address" className="flex items-center gap-1 text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    <MapPin className="w-3 h-3" /> Address
                                                </label>
                                                <textarea
                                                    id="address"
                                                    placeholder="Enter your complete address"
                                                    value={userData.address}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive} resize-none`}
                                                    rows="2"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Bank details + upload */}
                                    <div className="bg-white/70 dark:bg-white/5 rounded-2xl border border-gray-200/70 dark:border-gray-700/60 p-3">
                                        <div className="flex items-center gap-2 mb-2">
                                            <Landmark className="w-3.5 h-3.5 text-blue-500" />
                                            <h2 className="text-xs font-semibold text-gray-700 dark:text-gray-200">Bank Details</h2>
                                            <span className="ml-auto px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-[10px] rounded-full">Financial information</span>
                                        </div>

                                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                                            <div className={`relative ${hasExistingAccountHolder ? 'opacity-75' : ''}`}>
                                                <label htmlFor="account_holder" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    Account Holder {hasExistingAccountHolder && <span className="text-[9px] bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-1.5 rounded ml-1">Locked</span>}
                                                </label>
                                                <input
                                                    id="account_holder"
                                                    type="text"
                                                    placeholder="Account holder name"
                                                    value={hasExistingAccountHolder ? originalAccountHolder : userData.account_holder}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, ''); }}
                                                    disabled={hasExistingAccountHolder}
                                                    className={`${fieldBase} ${hasExistingAccountHolder ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`relative ${hasExistingBankName ? 'opacity-75' : ''}`}>
                                                <label htmlFor="bank_name" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    Bank Name {hasExistingBankName && <span className="text-[9px] bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-1.5 rounded ml-1">Locked</span>}
                                                </label>
                                                <input
                                                    id="bank_name"
                                                    type="text"
                                                    placeholder="Bank name"
                                                    value={hasExistingBankName ? originalBankName : userData.bank_name}
                                                    onChange={handleInputChange}
                                                    disabled={hasExistingBankName}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, ''); }}
                                                    className={`${fieldBase} ${hasExistingBankName ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`relative ${hasExistingAccount ? 'opacity-75' : ''}`}>
                                                <label htmlFor="account_no" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    Account No. {hasExistingAccount && <span className="text-[9px] bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-1.5 rounded ml-1">Locked</span>}
                                                </label>
                                                <input
                                                    id="account_no"
                                                    type="text"
                                                    placeholder="Account number"
                                                    value={hasExistingAccount ? originalAccountNo : userData.account_no}
                                                    maxLength={16}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }}
                                                    disabled={hasExistingAccount}
                                                    className={`${fieldBase} ${hasExistingAccount ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`relative ${hasExistingIfscCode ? 'opacity-75' : ''}`}>
                                                <label htmlFor="ifsc_code" className="block text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1">
                                                    IFSC Code {hasExistingIfscCode && <span className="text-[9px] bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-1.5 rounded ml-1">Locked</span>}
                                                </label>
                                                <input
                                                    id="ifsc_code"
                                                    type="text"
                                                    placeholder="IFSC code"
                                                    value={hasExistingIfscCode ? originalIfscCode : userData.ifsc_code}
                                                    onChange={handleInputChange}
                                                    disabled={hasExistingIfscCode}
                                                    className={`${fieldBase} ${hasExistingIfscCode ? fieldLocked : fieldActive}`}
                                                />
                                            </div>
                                        </div>

                                        {/* Cancel check upload */}
                                        <div className="mt-3 pt-3 border-t border-dashed border-gray-300 dark:border-gray-600 flex items-center gap-3 flex-wrap">
                                            <FileCheck2 className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                                            <label className="text-[11px] font-medium text-gray-500 dark:text-gray-400 shrink-0">
                                                Cancelled Check <span className="block text-[9px] text-gray-400 dark:text-gray-500">PDF, JPG, JPEG, PNG</span>
                                            </label>

                                            <input
                                                type="file"
                                                id="cancel-check-upload"
                                                className="hidden"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleCancelCheckUpload}
                                            />
                                            <label
                                                htmlFor="cancel-check-upload"
                                                className="flex items-center gap-1.5 bg-customPurple hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg cursor-pointer transition-all duration-200 text-xs font-medium shrink-0"
                                            >
                                                <Upload className="w-3.5 h-3.5" />
                                                <span>Choose File</span>
                                            </label>

                                            {cancelCheckFile && (
                                                <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 pl-3 pr-1.5 py-1.5 rounded-lg text-xs">
                                                    <div className="w-1.5 h-1.5 bg-green-500 rounded-full shrink-0"></div>
                                                    <span className="text-gray-700 dark:text-white truncate max-w-[8rem]">{cancelCheckFile.name}</span>
                                                    <button
                                                        onClick={handleCancelCheckRemove}
                                                        className="text-red-500 hover:text-red-700 transition-colors duration-200 p-1"
                                                        type="button"
                                                    >
                                                        <X className="w-3.5 h-3.5" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfileEdit;